/** Single source of truth for the customer URL space. */

export const CUSTOMER_ROUTE_PREFIX = "/app/customers"

/** Combined route path so `/app` and `/app/customers` 404 instead of rendering a blank outlet. */
export const CUSTOMER_ROUTE_PATTERN = `${CUSTOMER_ROUTE_PREFIX}/:customerId`

export function customerPath(customerId: string, ...segments: string[]): string {
  const rest = segments.filter((s) => s.length > 0).join("/")
  return rest
    ? `${CUSTOMER_ROUTE_PREFIX}/${customerId}/${rest}`
    : `${CUSTOMER_ROUTE_PREFIX}/${customerId}`
}

export function customerOverviewPath(customerId: string): string {
  return customerPath(customerId, "overview")
}

/**
 * Asset-area path. The segment is "assets" (matching the Assets nav group) —
 * "fleet" was wrong once batteries and sites lived here too.
 */
export function customerFleetPath(customerId: string, ...segments: string[]): string {
  return customerPath(customerId, "assets", ...segments)
}

/**
 * Rewrite a pre-rename `/app/customers/<id>/fleet/…` URL to its `assets`
 * equivalent so bookmarks and shared links keep working. Returns null when the
 * pathname is not a legacy customer fleet path.
 */
export function legacyCustomerFleetRedirect(pathname: string): string | null {
  const match = /^(\/app\/customers\/[^/]+)\/fleet(\/.*)?$/.exec(pathname)
  if (!match) return null
  return `${match[1]}/assets${match[2] ?? ""}`
}

/** True for `/app/customers/<id>` and descendants; false for `/app/customers` itself. */
export function isCustomerPath(pathname: string): boolean {
  const prefix = `${CUSTOMER_ROUTE_PREFIX}/`
  if (!pathname.startsWith(prefix)) return false
  const customerId = pathname.slice(prefix.length).split("/")[0]
  return Boolean(customerId)
}
